import { getIndexInFront } from "./threeScript";
import { animatePolygon } from "./SVGPolygonAnimation";
//get cols of central text
const canvas = document.querySelector(".webgl");
var btn_back = document.getElementById("btn-back");
var btn_top = document.getElementById("btn-top");
const animation_SVG_forward = document.getElementById('animation-forward');
const animation_SVG_backward = document.getElementById('animation-backward');
const detail_mf = document.getElementById('mf-details');
const HEIGHT_LETTER_CELL = 70;
const detail_section = document.getElementById('detail-section');
const btnCloseProjectMobile = document.getElementById('btn-close-project');
const mainImgSection = document.getElementById("main-img-section");

const central_elements = document.getElementById('central-elements');
const centralElementsContainer = document.getElementById('central-elements-container');

const col_1 = document.getElementById('ct-col-1');
const col_2 = document.getElementById('ct-col-2');
const col_3 = document.getElementById('ct-col-3');
const col_4 = document.getElementById('ct-col-4');
const col_5 = document.getElementById('ct-col-5');
const col_6 = document.getElementById('ct-col-6');
const col_7 = document.getElementById('ct-col-7');
const col_8 = document.getElementById('ct-col-8');
const col_9 = document.getElementById('ct-col-9');
const col_10 = document.getElementById('ct-col-10');
const col_11 = document.getElementById('ct-col-11');

const centralTextListFunction = [showRetronewsTextAnimation, showManagerTextAnimation, showAnazirTextAnimation, showMobileFoodTextAnimation]


// about btn
const btnCloseAbout = document.getElementById('btn-close-about');
const btnOpenAbout = document.getElementById('btn-open-about');
const aboutSection = document.getElementById("about-section");
const btnAboutContainer = document.getElementById("btn-about-container");

//gallery
var gallery_container = document.getElementById('gallery-container');
var gallery_mf = document.getElementById('mf-gallery');
var img_mf_1 = gallery_mf.querySelector('.first');
var img_mf_2 = gallery_mf.querySelector('.second');
var img_mf_3 = gallery_mf.querySelector('.third');
var selector_1 = gallery_mf.querySelector('.selector-1');
var selector_2 = gallery_mf.querySelector('.selector-2');
var selector_3 = gallery_mf.querySelector('.selector-3');


const imgSelector1 = selector_1.querySelector('img');
const imgSelector2 = selector_2.querySelector('img');
const imgSelector3 = selector_3.querySelector('img');

var selector_1 = gallery_mf.querySelector('.selector-1');
var selector_2 = gallery_mf.querySelector('.selector-2');
var selector_3 = gallery_mf.querySelector('.selector-3');

const tb_qt_1 = document.getElementById('tb-qt-1');
const tb_qt_2 = document.getElementById('tb-qt-2');
const tb_qt_3 = document.getElementById('tb-qt-3');

const outlineSelected = document.getElementById("outline-selected");

const selectorList=[selector_1, selector_2, selector_3];


function initOutlineSelected() {
    //outlineSelected.style.transition = 'opacity 0.5s';
    //outlineSelected.style.opacity = 1;
   // setTimeout(() => { outlineSelected.style.transition = 'transform 0.7s cubic-bezier(0,.21,0,1)' }, 200);
    //;
}
function moveOutlineSelected(elt) {
    const position = elt.getBoundingClientRect();
    const outline_rect = outlineSelected.getBoundingClientRect();
    const target = position.top - outline_rect.top;
    const selectedTranslation=outline_rect.top;
    outlineSelected.style.transform = "translateY(" + (selectedTranslation + target) + "px)";

    
    
    
    
}
function majSelector(imgSelected){
    selectorList.forEach((element, i) => {
            if(i===imgSelected-1){
                element.classList.add("selected")
            }
            else{
                element.classList.remove("selected");
                
            }
    });
}
function centerFromTheTop(img) {
    img.style.transition = "none";
    moveOutScreenUp(img);
    img.style.transition = "transform 1s";
    img.style.transform = "translateY(0px)";
    //img.style.transition="none";
}
function centerFromTheBottom(img) {
    img.style.transition = "none";
    moveOutScreendown(img);
    img.style.transition = "transform 1s ";
    img.style.transform = "translateY(0px)";
    //img.style.transition="none";
}
function showAboutTextAnimation() {
    col_1.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "0px)";

    col_4.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";

    col_9.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
}

function moveToCenterGallery(img) {
    centerFromTheBottom(img);

}
function getTranslateY(elt) {
    var style = window.getComputedStyle(elt);
    var matrix = new WebKitCSSMatrix(style.transform);
    return matrix.m42;
}
function moveOutScreendown(elt) {
    const actualTranslate = getTranslateY(elt);
    const top = elt.getBoundingClientRect().top;
    const screenHeight = window.innerHeight;
    const distance = screenHeight - top + actualTranslate+1;

    elt.style.transform = "translateY(" + distance + "px)";
}
function moveOutScreendownImediatly(elt){
    const actualTranslate = getTranslateY(elt);
    const top = elt.getBoundingClientRect().top;
    const screenHeight = window.innerHeight;
    const distance = screenHeight - top + actualTranslate+1;
    removeTransitionFor(elt, 50);
    elt.style.transform = "translateY(" + distance + "px)";
    
}
function removeTransitionFor(elt, duration){
    elt.classList.add("no-transition") ;
    setTimeout(()=>{ elt.classList.remove("no-transition") ;}, duration);
}
function moveOutScreenUp(elt) {
    const actualTranslate = getTranslateY(elt);

    const bottom = elt.getBoundingClientRect().bottom;
    const distance = bottom - actualTranslate;

    elt.style.transform = "translateY(-" + distance + "px)";
}
function translateAboutBtn(factor) {
    btnCloseAbout.style.transform = `translateY(${factor * 25}px)`;
    btnOpenAbout.style.transform = `translateY(${factor * 25}px)`;
}

function endCursorHoverLineAnimation() {
    document.body.style.cursor = 'default';
    cursor.style.cursor = "default";
    cursor.setAttribute("deployed", false);
    cursor.querySelectorAll("svg").forEach((child, i) => {

        child.style.height = "20px";
        child.style.width = "20px";
        //child.style.height = `${factor * size}px`;
        child.style.animation = "none";
        if (i === 0) {
            child.style.fill = 'transparent';
        }

    })

    cursor.querySelector("span").style.opacity = 0;


}
function putMainImageFullScreen() {

    canvas.style.filter = "blur(80px)";


}
function unPutMainImageFullScreen() {
    canvas.style.filter = "blur(0px)";
}

function initGalleryPosition(){
    moveOutScreendown(img_mf_1);
    moveOutScreendown(img_mf_2);
    moveOutScreendown(img_mf_3);
    moveOutScreendown(selector_1);
    moveOutScreendown(selector_2);
    moveOutScreendown(selector_3);
    moveOutScreendown(outlineSelected);

    
}

function showGallery() {
    

    majSelector(1);
    moveToCenterGallery(img_mf_1);
    moveToCenterGallery(selector_1);
    moveToCenterGallery(outlineSelected);
    moveToCenterGallery(selector_2);
    moveToCenterGallery(selector_3);
    
}


function showBackBtnAnimation() {
    btn_back.style.transform = "translateY(0px)";
    const polygon = document.querySelector('polygon');

    setTimeout(() => { animatePolygon(polygon, "11.75,20  11.75,0    13.25,0    13.25,20  12.5,20  12.5,1.75  12.5,20",500) }, 200);
    setTimeout(() => { animatePolygon(polygon, "0,7 12.5,0 12.5,0 25,7 22,7 12.5,1.75 3,7",500) }, 700);
    btn_top.style.pointerEvents = "auto";


}
function collapseBackBtnAnimation() {
    btn_back.style.transform = "translateY(30px)"
    const polygon = document.querySelector('polygon');
    animatePolygon(polygon, "11.75,20  11.75,0    13.25,0    13.25,20  12.5,20  12.5,1.75  12.5,20",500).then(()=>{
        animatePolygon(polygon, "12,20  12,20   13,20   13,20  12.5,20  12.5,1.20  12.5,20",500) }
    );
    
    btn_top.style.pointerEvents = "none";


}




function collapseTBQT() {
    tb_qt_1.animate({
        transform: "rotate(360deg)",
        width: 0
    }, { duration: 1000, fill: "forwards", easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_2.animate({
        transform: "rotate(-360deg)",
        width: 0
    }, { duration: 1000, fill: "forwards", easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_3.animate({
        transform: "rotate(360deg)",
        width: 0
    }, { duration: 1000, fill: "forwards", easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
}
function showWorkTextAnimation() {
    col_1.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + -6 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
}
function allColEmpty() {
    col_1.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -8 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
}

function showMobileFoodTextAnimation() {

    col_1.style.transform = "translateY(" + 0 + "px)";
    col_2.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";

}
function showAnazirTextAnimation() {
    col_1.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -6 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    //rotate_tbqt();
}
function showManagerTextAnimation() {
    col_1.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    //rotate_tbqt();
}
function showRetronewsTextAnimation() {
    col_1.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + -7 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    //rotate_tbqt();
}

function executeCentralTextFunction(i) {
    //centralTextListFunction[getIndexInFront()]();

    centralTextListFunction[i]();
}

function showDetails() {
    const details_container = detail_mf.querySelector(".details-container");
    details_container.style.transform = "translateY(0)";
}
function hideDetails() {
    const details_container = detail_mf.querySelector(".details-container");
    details_container.style.transform = "translateY(25px)";
}
function hideGallery(selected) {
    if(selected===2){
        moveOutScreendownImediatly(img_mf_1)
        moveOutScreendown(img_mf_2);
    
    }
    else if(selected==3){
        moveOutScreendownImediatly(img_mf_1)
        moveOutScreendownImediatly(img_mf_2)
        moveOutScreendown(img_mf_3);

    }
    else{
        moveOutScreendown(img_mf_1);
       
    }
    moveOutScreendown(outlineSelected);
    moveOutScreendown(selector_1);
    moveOutScreendown(selector_2);
    moveOutScreendown(selector_3);

}
function moveCol(advancement) {
    const factor=HEIGHT_LETTER_CELL*advancement
    col_1.style.transform = "translateY(" + -3 * factor + "px)";
    col_2.style.transform = "translateY(" + factor + "px)";
    col_3.style.transform = "translateY(" + -5 * factor + "px)";
    col_4.style.transform = "translateY(" + -5 * factor + "px)";
    col_5.style.transform = "translateY(" + factor + "px)";
    col_6.style.transform = "translateY(" + factor + "px)";
    col_7.style.transform = "translateY(" + factor + "px)";
    col_8.style.transform = "translateY(" + factor + "px)";
    col_9.style.transform = "translateY(" + factor + "px)";
    col_10.style.transform = "translateY(" + -4 * factor + "px)";
    col_11.style.transform = "translateY(" + factor + "px)";
}
function showTBQT() {

    tb_qt_1.animate({
        transform: "rotate(0deg)",
        width: "275px"

    }, { duration: 1000, fill: "forwards", easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_2.animate({
        transform: "rotate(0deg)",
        width: "275px"
    }, { duration: 1000, fill: "forwards", easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_3.animate({
        transform: "rotate(0deg)",
        width: "275px"
    }, { duration: 1000, fill: "forwards", easing: "cubic-bezier(0, 0.30, 0.19, 1)" });

}
function moveUpCentralElements() {
    const central_elements = document.getElementById('central-elements');
    central_elements.style.transition = "transform 1s cubic-bezier(.1,0,.10,1)"
    central_elements.style.transform = "translateY(-200px )";
}

function showAboutSection() {
    const aboutSection = document.getElementById("about-section");
    aboutSection.style.transform = "translateX(0)";
    aboutSection.style.opacity = "1";
    
}
function hideAboutSection() {
    const aboutSection = document.getElementById("about-section");
    aboutSection.style.opacity = "0";
    setTimeout(() => { moveOutScreendown(aboutSection); }, 500);
}
function replaceCentralElements() {
    const central_elements = document.getElementById('central-elements');
    central_elements.style.transition = "transform 1s cubic-bezier(.1,0,.10,1)"
    central_elements.style.transform = "translate(0, 0)";
}
function enableAboutBtnHover(){
    btnAboutContainer.style.pointerEvents="auto";
}
function disableAboutBtnHover(){
    btnAboutContainer.style.pointerEvents="none";
}
function hideHomeMobile(){
    mainImgSection.style.opacity = 0;
    aboutSection.style.opacity = 0;
}
function hideDetailMobile(){
    detail_section.style.opacity = 0;
    btnCloseProjectMobile.style.opacity = 0;
}

function showDetailsMobile() {
    mainImgSection.style.display = "none";
    aboutSection.style.display = "none";
    mainImgSection.style.display = "none";
    //inDetailPageMobile = true;
    detail_section.style.display = "flex";
    btnCloseProjectMobile.style.display = "block";
    centralElementsContainer.style.position = "relative";
    central_elements.style.position = "relative";
    centralElementsContainer.style.marginTop = "100px";
    //centralElementsContainer.style.marginBottom = "100px";
    centralElementsContainer.style.top = "0";


    

    setTimeout(() => { detail_section.style.opacity = 1 }, 100);
    setTimeout(() => { btnCloseProjectMobile.style.opacity = 1 }, 100);


    centralElementsContainer.scrollIntoView(false);

}
function detailToHomeFirstPart(){
    detail_section.style.display = "none"
                btnCloseProjectMobile.style.display = "none" 
        
                mainImgSection.style.display = "flex";
                aboutSection.style.display = "flex" ;
                centralElementsContainer.removeAttribute("style");
}
function detailToHomeSecondPart(){
    mainImgSection.style.opacity = 1 ;
    aboutSection.style.opacity = 1;
}













export {
    showWorkTextAnimation,
    detailToHomeFirstPart,
    detailToHomeSecondPart,
    hideDetailMobile,
    hideHomeMobile,
    showDetailsMobile,
    disableAboutBtnHover,
    enableAboutBtnHover,
    removeTransitionFor,
    hideAboutSection,
    replaceCentralElements,
    moveUpCentralElements,
    showAboutSection,
    moveOutScreendown,
    moveOutScreenUp,
    showAboutTextAnimation,
    translateAboutBtn,
    executeCentralTextFunction,
    collapseTBQT,
    majSelector,
    collapseBackBtnAnimation,
    showBackBtnAnimation,
    allColEmpty,
    showGallery,
    putMainImageFullScreen,
    endCursorHoverLineAnimation,
    showDetails,
    moveCol, 
    hideDetails,
    hideGallery,
    unPutMainImageFullScreen,
    showTBQT,
    showMobileFoodTextAnimation,
    showRetronewsTextAnimation,
    initGalleryPosition,
}